'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Checkbox, Chip, Input } from '@common/components';
import { useDebouncedValue, useToast } from '@common/hooks';
import { cn } from '@core/utils';
import { useState } from 'react';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import type { SEARCH_PARAMS_TYPE } from '@/constants';
import { RegionMap } from './RegionMap';
import type { WelloPolicyCode } from './useRegionMetaData';
import { useRegionMetaData } from './useRegionMetaData';
export interface SelectedRegion {
  mainRegion?: WelloPolicyCode;
  subRegion?: WelloPolicyCode;
}
interface RegionPickerDialogProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: (region: SelectedRegion) => void;
  value?: SEARCH_PARAMS_TYPE.SELECTED_REGION;
  title: string;
  enableMainRegionCodeList?: string[];
  enableWholeRegion?: boolean;
  enableWholeCountry?: boolean;
  wholeCountryHint?: string;
}
const DEFAULT_SIDO_CODE = 'C01-01';
export const RegionPickerDialog = t0 => {
  const $ = _c(112);
  const {
    opened,
    onClose,
    onConfirm,
    value,
    title,
    enableMainRegionCodeList,
    enableWholeRegion: t1,
    enableWholeCountry: t2,
    wholeCountryHint: t3
  } = t0;
  const enableWholeRegion = t1 === undefined ? false : t1;
  const enableWholeCountry = t2 === undefined ? false : t2;
  const wholeCountryHint = t3 === undefined ? "\uCCB4\uD06C\uB97C \uD574\uC81C\uD558\uBA74 \uC2DC\xB7\uB3C4\xB7\uC2DC\xB7\uAD70\xB7\uAD6C\uB97C \uC9C1\uC811 \uACE0\uB97C \uC218 \uC788\uC5B4\uC694." : t3;
  const regionMetaData = useRegionMetaData().data;
  const {
    toast
  } = useToast();
  const [selectedValue, setSelectedValue] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [prevOpened, setPrevOpened] = useState(opened);
  if (opened !== prevOpened) {
    setPrevOpened(opened);
    if (opened) {
      setSelectedValue(value?.mainRegionCode ? value : enableWholeCountry ? {} : {
        mainRegionCode: DEFAULT_SIDO_CODE
      });
      setSearchInput("");
    }
  }
  let t4;
  if ($[0] !== searchInput) {
    t4 = searchInput.trim();
    $[0] = searchInput;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const searchKeyword = useDebouncedValue(t4, 200);
  let T0;
  let handleConfirm;
  let isWholeCountrySelected;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== enableMainRegionCodeList || $[3] !== enableWholeCountry || $[4] !== enableWholeRegion || $[5] !== onClose || $[6] !== onConfirm || $[7] !== opened || $[8] !== regionMetaData?.mainRegion || $[9] !== regionMetaData?.mainRegionByCode || $[10] !== regionMetaData?.subRegion || $[11] !== regionMetaData?.subRegionByCode || $[12] !== regionMetaData?.subRegionByParent || $[13] !== searchInput || $[14] !== searchKeyword || $[15] !== selectedValue || $[16] !== title || $[17] !== toast) {
    let t19;
    if ($[35] !== enableMainRegionCodeList) {
      t19 = mainRegion => {
        if (!enableMainRegionCodeList) {
          return true;
        }
        return enableMainRegionCodeList.includes(mainRegion.code ?? "");
      };
      $[35] = enableMainRegionCodeList;
      $[36] = t19;
    } else {
      t19 = $[36];
    }
    const mainRegionList = (regionMetaData?.mainRegion ?? []).filter(t19);
    const enabledSidoCodes = new Set(mainRegionList.map(_temp).filter(_temp2));
    let t20;
    if ($[37] !== searchInput) {
      t20 = searchInput.trim();
      $[37] = searchInput;
      $[38] = t20;
    } else {
      t20 = $[38];
    }
    const isSearchMode = t20.length > 0;
    const sidoNameByCode = new Map(mainRegionList.map(_temp3));
    const searchResults = searchKeyword ? (regionMetaData?.subRegion ?? []).flatMap(item => {
      const {
        code: code_2,
        value: value_1,
        parentCode
      } = item;
      if (!code_2 || !value_1 || !parentCode) {
        return [];
      }
      if (!enabledSidoCodes.has(parentCode)) {
        return [];
      }
      const sidoName = sidoNameByCode.get(parentCode) ?? "";
      if (!value_1.includes(searchKeyword) && !sidoName.includes(searchKeyword)) {
        return [];
      }
      return [{
        code: code_2,
        value: value_1,
        parentCode,
        sidoName
      }];
    }) : [];
    let t21;
    if ($[39] !== regionMetaData?.mainRegionByCode || $[40] !== selectedValue) {
      t21 = selectedValue?.mainRegionCode ? regionMetaData?.mainRegionByCode.get(selectedValue.mainRegionCode)?.value : undefined;
      $[39] = regionMetaData?.mainRegionByCode;
      $[40] = selectedValue;
      $[41] = t21;
    } else {
      t21 = $[41];
    }
    const selectedMainRegionName = t21;
    const subRegionList = selectedValue?.mainRegionCode ? regionMetaData?.subRegionByParent.get(selectedValue.mainRegionCode) ?? [] : [];
    isWholeCountrySelected = enableWholeCountry && !selectedValue?.mainRegionCode;
    let t22;
    if ($[42] !== enableWholeRegion || $[43] !== isWholeCountrySelected || $[44] !== onClose || $[45] !== onConfirm || $[46] !== regionMetaData?.mainRegionByCode || $[47] !== regionMetaData?.subRegionByCode || $[48] !== selectedValue || $[49] !== toast) {
      t22 = () => {
        if (isWholeCountrySelected) {
          onConfirm({
            mainRegion: undefined,
            subRegion: undefined
          });
          onClose();
          return;
        }
        const mainRegion_0 = selectedValue?.mainRegionCode ? regionMetaData?.mainRegionByCode.get(selectedValue.mainRegionCode) : undefined;
        const subRegion = selectedValue?.subRegionCode ? regionMetaData?.subRegionByCode.get(selectedValue.subRegionCode) : undefined;
        if (!mainRegion_0 || !enableWholeRegion && !subRegion) {
          toast({
            message: "\uC9C0\uC5ED \uC815\uBCF4\uB97C \uAC00\uC838\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694."
          });
          return;
        }
        onConfirm({
          mainRegion: mainRegion_0,
          subRegion
        });
        onClose();
      };
      $[42] = enableWholeRegion;
      $[43] = isWholeCountrySelected;
      $[44] = onClose;
      $[45] = onConfirm;
      $[46] = regionMetaData?.mainRegionByCode;
      $[47] = regionMetaData?.subRegionByCode;
      $[48] = selectedValue;
      $[49] = toast;
      $[50] = t22;
    } else {
      t22 = $[50];
    }
    handleConfirm = t22;
    T0 = ResponsiveDialog;
    t14 = opened;
    t15 = onClose;
    t16 = "bottom";
    t17 = title;
    t18 = title;
    t11 = "flex flex-col";
    let t23;
    let t24;
    if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
      t23 = event => {
        setSearchInput(event.target.value);
      };
      t24 = () => {
        setSearchInput("");
      };
      $[51] = t23;
      $[52] = t24;
    } else {
      t23 = $[51];
      t24 = $[52];
    }
    if ($[53] !== isWholeCountrySelected || $[54] !== searchInput) {
      t12 = <Input className="w-full" type="search" placeholder={"\uC2DC\xB7\uAD70\xB7\uAD6C\uB85C \uAC80\uC0C9\uD574 \uBCF4\uC138\uC694"} disabled={isWholeCountrySelected} value={searchInput} onChange={t23} onClear={t24} />;
      $[53] = isWholeCountrySelected;
      $[54] = searchInput;
      $[55] = t12;
    } else {
      t12 = $[55];
    }
    if ($[56] !== enableWholeCountry || $[57] !== isWholeCountrySelected) {
      t13 = enableWholeCountry ? <Checkbox className="mt-4" checked={isWholeCountrySelected} onCheckedChange={checked => {
        setSearchInput("");
        setSelectedValue(checked ? {} : {
          mainRegionCode: DEFAULT_SIDO_CODE
        });
      }}>전국 보기</Checkbox> : null;
      $[56] = enableWholeCountry;
      $[57] = isWholeCountrySelected;
      $[58] = t13;
    } else {
      t13 = $[58];
    }
    t10 = "relative";
    t8 = isWholeCountrySelected || undefined;
    const t25 = isWholeCountrySelected && "pointer-events-none select-none blur-sm";
    if ($[59] !== t25) {
      t9 = cn(t25);
      $[59] = t25;
      $[60] = t9;
    } else {
      t9 = $[60];
    }
    t5 = "relative";
    const t26 = isSearchMode && "invisible";
    let t27;
    if ($[61] !== t26) {
      t27 = cn("flex flex-col gap-20", t26);
      $[61] = t26;
      $[62] = t27;
    } else {
      t27 = $[62];
    }
    let t28;
    if ($[63] !== selectedValue?.mainRegionCode) {
      t28 = code_3 => {
        if (code_3 === selectedValue?.mainRegionCode) {
          return;
        }
        setSelectedValue({
          mainRegionCode: code_3
        });
      };
      $[63] = selectedValue?.mainRegionCode;
      $[64] = t28;
    } else {
      t28 = $[64];
    }
    let t29;
    if ($[65] !== selectedMainRegionName) {
      t29 = <span className="font-600 text-Gray-900 typo-body3">{selectedMainRegionName}</span>;
      $[65] = selectedMainRegionName;
      $[66] = t29;
    } else {
      t29 = $[66];
    }
    const t30 = selectedValue?.mainRegionCode;
    let t31;
    if ($[67] !== enableWholeRegion || $[68] !== selectedValue?.mainRegionCode || $[69] !== selectedValue?.subRegionCode) {
      t31 = enableWholeRegion && selectedValue?.mainRegionCode ? <li><Chip checked={!selectedValue?.subRegionCode} onCheckedChange={() => {
          setSelectedValue(_temp4);
        }}>전체</Chip></li> : null;
      $[67] = enableWholeRegion;
      $[68] = selectedValue?.mainRegionCode;
      $[69] = selectedValue?.subRegionCode;
      $[70] = t31;
    } else {
      t31 = $[70];
    }
    let t32;
    if ($[71] !== selectedValue?.subRegionCode) {
      t32 = t33 => {
        const {
          code: code_4,
          value: value_2
        } = t33;
        if (!code_4 || !value_2) {
          return null;
        }
        const isSelected = code_4 === selectedValue?.subRegionCode;
        return <li key={code_4}><Chip checked={isSelected} onCheckedChange={() => {
            setSelectedValue(previousValue_0 => ({
              ...previousValue_0,
              subRegionCode: code_4
            }));
          }}>{value_2}</Chip></li>;
      };
      $[71] = selectedValue?.subRegionCode;
      $[72] = t32;
    } else {
      t32 = $[72];
    }
    const t33 = subRegionList.map(t32);
    let t34;
    if ($[73] !== t30 || $[74] !== t31 || $[75] !== t33) {
      t34 = <ul key={t30} className="flex h-180 flex-wrap content-start gap-8 overflow-auto hide-scrollbar webkit-scroll-touch">{t31}{t33}</ul>;
      $[73] = t30;
      $[74] = t31;
      $[75] = t33;
      $[76] = t34;
    } else {
      t34 = $[76];
    }
    let t35;
    if ($[77] !== t29 || $[78] !== t34) {
      t35 = <div className="flex flex-col gap-10">{t29}{t34}</div>;
      $[77] = t29;
      $[78] = t34;
      $[79] = t35;
    } else {
      t35 = $[79];
    }
    t6 = <div className={t27}><RegionMap selectedSidoCode={selectedValue?.mainRegionCode} onSelectSido={t28} enabledSidoCodes={enabledSidoCodes} />{t35}</div>;
    t7 = isSearchMode ? searchKeyword && searchResults.length === 0 ? <div className="absolute inset-0 flex items-center justify-center bg-Gray-white text-Gray-400 typo-body3">검색 결과가 없어요.</div> : <ul className="absolute inset-0 flex flex-col overflow-auto bg-Gray-white hide-scrollbar webkit-scroll-touch">{searchResults.map(t36 => {
        const {
          code: code_5,
          value: value_3,
          parentCode: parentCode_0,
          sidoName: sidoName_0
        } = t36;
        return <li key={code_5}><button type="button" className="flex w-full items-baseline gap-6 rounded-medium p-12 text-left transition-colors hover:bg-Gray-50" onClick={() => {
            setSelectedValue({
              mainRegionCode: parentCode_0,
              subRegionCode: code_5
            });
            setSearchInput("");
          }}><span className="font-500 text-Gray-900 typo-body3">{value_3}</span><span className="text-Gray-400 typo-caption1">{sidoName_0}</span></button></li>;
      })}</ul> : null;
    $[2] = enableMainRegionCodeList;
    $[3] = enableWholeCountry;
    $[4] = enableWholeRegion;
    $[5] = onClose;
    $[6] = onConfirm;
    $[7] = opened;
    $[8] = regionMetaData?.mainRegion;
    $[9] = regionMetaData?.mainRegionByCode;
    $[10] = regionMetaData?.subRegion;
    $[11] = regionMetaData?.subRegionByCode;
    $[12] = regionMetaData?.subRegionByParent;
    $[13] = searchInput;
    $[14] = searchKeyword;
    $[15] = selectedValue;
    $[16] = title;
    $[17] = toast;
    $[18] = T0;
    $[19] = handleConfirm;
    $[20] = isWholeCountrySelected;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
    $[29] = t18;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
  } else {
    T0 = $[18];
    handleConfirm = $[19];
    isWholeCountrySelected = $[20];
    t10 = $[21];
    t11 = $[22];
    t12 = $[23];
    t13 = $[24];
    t14 = $[25];
    t15 = $[26];
    t16 = $[27];
    t17 = $[28];
    t18 = $[29];
    t5 = $[30];
    t6 = $[31];
    t7 = $[32];
    t8 = $[33];
    t9 = $[34];
  }
  let t19;
  if ($[80] !== t5 || $[81] !== t6 || $[82] !== t7) {
    t19 = <div className={t5}>{t6}{t7}</div>;
    $[80] = t5;
    $[81] = t6;
    $[82] = t7;
    $[83] = t19;
  } else {
    t19 = $[83];
  }
  let t20;
  if ($[84] !== t19 || $[85] !== t8 || $[86] !== t9) {
    t20 = <div aria-hidden={t8} className={t9}>{t19}</div>;
    $[84] = t19;
    $[85] = t8;
    $[86] = t9;
    $[87] = t20;
  } else {
    t20 = $[87];
  }
  let t21;
  if ($[88] !== isWholeCountrySelected || $[89] !== wholeCountryHint) {
    t21 = isWholeCountrySelected ? <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-Gray-white/60 text-center"><p className="m-0 font-600 text-Gray-900 typo-body2">전국을 보고 있어요</p><p className="m-0 text-Gray-500 typo-body4">{wholeCountryHint}</p></div> : null;
    $[88] = isWholeCountrySelected;
    $[89] = wholeCountryHint;
    $[90] = t21;
  } else {
    t21 = $[90];
  }
  let t22;
  if ($[91] !== t10 || $[92] !== t20 || $[93] !== t21) {
    t22 = <div className={t10}>{t20}{t21}</div>;
    $[91] = t10;
    $[92] = t20;
    $[93] = t21;
    $[94] = t22;
  } else {
    t22 = $[94];
  }
  let t23;
  if ($[95] !== t11 || $[96] !== t12 || $[97] !== t13 || $[98] !== t22) {
    t23 = <div className={t11}>{t12}{t13}{t22}</div>;
    $[95] = t11;
    $[96] = t12;
    $[97] = t13;
    $[98] = t22;
    $[99] = t23;
  } else {
    t23 = $[99];
  }
  const t24 = !isWholeCountrySelected && (!selectedValue?.mainRegionCode || !enableWholeRegion && !selectedValue?.subRegionCode);
  let t25;
  if ($[100] !== handleConfirm || $[101] !== t24) {
    t25 = <div className="sticky bottom-0 border-t border-Gray-100 bg-Gray-white pt-12"><Button className="w-full" disabled={t24} onClick={handleConfirm}>선택 완료</Button></div>;
    $[100] = handleConfirm;
    $[101] = t24;
    $[102] = t25;
  } else {
    t25 = $[102];
  }
  let t26;
  if ($[103] !== T0 || $[104] !== t14 || $[105] !== t15 || $[106] !== t16 || $[107] !== t17 || $[108] !== t18 || $[109] !== t23 || $[110] !== t25) {
    t26 = <T0 opened={t14} onClose={t15} drawerType={t16} title={t17} modalHeader={t18}>{t23}{t25}</T0>;
    $[103] = T0;
    $[104] = t14;
    $[105] = t15;
    $[106] = t16;
    $[107] = t17;
    $[108] = t18;
    $[109] = t23;
    $[110] = t25;
    $[111] = t26;
  } else {
    t26 = $[111];
  }
  return t26;
};
function _temp(t0) {
  const {
    code
  } = t0;
  return code;
}
function _temp2(code_0) {
  return Boolean(code_0);
}
function _temp3(t0) {
  const {
    code: code_1,
    value: value_0
  } = t0;
  return [code_1, value_0];
}
function _temp4(previousValue) {
  return {
    ...previousValue,
    subRegionCode: undefined
  };
}